<dt-modal-content size="small" [contentPadding]="false" (closeClick)="close()" [showFooter]="!isTaskSingleton">
  <ng-template #title>{{ teamsTasksService.getTaskTypeName(task) }}</ng-template>
  <ng-template #content>
    <mat-list>
      <mat-list-item>
        <span matListItemTitle i18n>Zugewiesen</span>
        <span matListItemLine>{{ task.createdAt | date: 'short' }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle i18n>Zuletzt geändert</span>
        <span matListItemLine>{{ task.updatedAt | date: 'short' }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle i18n>Status</span>
        <span matListItemLine
          >{{ taskState[1] }}
          @if (taskState[2]) {
            <span> ({{ taskState[2] }})</span>
          }
        </span>
      </mat-list-item>
      <mat-list-item class="edit-task" (click)="!isEditingLocked && editTask()" [disabled]="isEditingLocked">
        <span matListItemTitle>
          @if (task.submitted) {
            <ng-container i18n>Aufgabe ansehen</ng-container>
          } @else {
            <ng-container i18n>Aufgabe bearbeiten</ng-container>
          }
        </span>
        <div matListItemMeta>
          <mat-icon
            color="accent"
            i18n-matTooltip
            [matTooltipDisabled]="!isEditingLocked"
            matTooltip="Das Bearbeiten dieses Aufgabentyps wurde vom Moderator gesperrt."
            >{{ isEditingLocked ? 'lock' : task.submitted ? 'visibility' : 'edit' }}</mat-icon
          >
        </div>
      </mat-list-item>
    </mat-list>
  </ng-template>
  <ng-template #footer>
    <div
      i18n-matTooltip
      matTooltip="Um eine Aufgabe zu übernehmen benötigst Du das Bearbeitungsrecht für das Projekt."
      [matTooltipDisabled]="hasEditRight"
    >
      @if (task.submitted && canApplyTask) {
        <button [disabled]="!hasEditRight" mat-raised-button color="accent" type="button" (click)="applyTask()">
          <mat-icon>move_up</mat-icon>
          <ng-container i18n>Aufgabe ins Projekt übernehmen</ng-container>
        </button>
      }
    </div>
    @if (task.submitted) {
      <button mat-raised-button color="accent" type="button" (click)="submitTask()" [disabled]="task.submitted">
        <mat-icon>check</mat-icon>
        <ng-container i18n>Aufgabe abgegeben</ng-container>
      </button>
    }
    @if (!task.submitted) {
      <button i18n mat-raised-button color="accent" type="button" (click)="submitTask()" [disabled]="task.submitted"
        >Aufgabe abgeben</button
      >
    }
  </ng-template>
</dt-modal-content>
